import { MenuItem } from '@material-ui/core';
import React from 'react';
import { useConfigComponent } from '../../hooks/component/useConfigComponent';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { SiteComponent } from '../SiteComponentPlugin';
import { ConfigFieldControl, ConfigTextField } from '@sierralabs/core-ui';
import { useSiteContext } from '../../SiteContext';
export const SiteMenuItem = props => {
    const component = useSubscribeComponentChanges(SiteMenuItemPlugin, props);
    const { text } = component.props || {};
    const { isHover, hoverProps } = useSiteContext();
    const classes = ['site-menu-item'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: SiteMenuItemPlugin }, props),
        React.createElement(MenuItem, Object.assign({ className: classes.join(' ') }, hoverProps(component)), text || '')));
};
export const SiteMenuItemConfigurator = props => {
    var _a;
    const { component, update } = useConfigComponent(props.component);
    return (React.createElement(ConfigFieldControl, null,
        React.createElement(ConfigTextField, { fullWidth: true, label: 'Menu Item Text', value: ((_a = component.props) === null || _a === void 0 ? void 0 : _a.text) || '', onChange: event => {
                update('props.text', event.target.value);
            } })));
};
export const SiteMenuItemPlugin = {
    name: 'Menu Item',
    type: 'menu-item',
    component: SiteMenuItem,
    configurator: SiteMenuItemConfigurator,
    initConfig: component => {
        if (!component.props)
            component.props = {};
        component.props.text = 'Text';
        return component;
    }
};
//# sourceMappingURL=SiteMenuItemPlugin.js.map